import React, { useContext } from 'react';
import { useFeatureFlagsInternal } from './UseFeatureFlags';

type FeatureFlagsContext = ReturnType<typeof useFeatureFlagsInternal>;

const initialContext: FeatureFlagsContext = {
  isFlagEnabled: () => false, // initialize as false until Contentful returns with Feature Flags
  isFetched: false,
};

const FeatureFlag = React.createContext<FeatureFlagsContext>(initialContext);
FeatureFlag.displayName = 'FeatureFlags';

export const useFeatureFlagsContext = () => useContext(FeatureFlag);

export const FeatureFlagsProvider: React.FC = ({ children }) => {
  return <FeatureFlag.Provider value={useFeatureFlagsInternal()}>{children}</FeatureFlag.Provider>;
};
